<template>
    <div ref="root" class="modulemove">
        <a
            class="modulemove__button modulemove__button--up"
            v-if="!first"
            v-on:click.prevent="$emit('move-up')"
            href="#"
            v-tooltip.right="$helpers.uiText('U008')"
        ></a>
        <div
            v-if="showMove"
            class="modulemove__button modulemove__button--drag"
            v-tooltip.right="$helpers.uiText('U010')"
        >
            :::
        </div>
        <a
            class="modulemove__button modulemove__button--down"
            v-if="!last"
            v-on:click.prevent="$emit('move-down')"
            href="#"
            v-tooltip.right="$helpers.uiText('U009')"
        ></a>
    </div>
</template>

<script>
import { isTouchDevice } from '@/helpers/utils';
export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        showMove() {
            return !isTouchDevice();
        }
    },
    created() {},
    mounted() {},
    watch: {},
    props: {
        first: Boolean,
        last: Boolean
    }
};
</script>
